import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CheckCircle2, AlertTriangle } from 'lucide-react';

import { AuthLayout } from '@/components/auth/AuthLayout';

export default function VerifyEmail() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const success = searchParams.get('type') === 'success';

  return (
    <AuthLayout title={success ? t('COMMON.EMAIL_ADDRESS_VERIFIED') : t('COMMON.TOKEN_EXPIRED')}>
      <div className="flex flex-col items-center gap-3 py-4 text-center">
        {success ? (
          <CheckCircle2 className="h-12 w-12 text-green-600" />
        ) : (
          <AlertTriangle className="h-12 w-12 text-amber-500" />
        )}
        <Link to="/login" className="text-sm text-primary hover:underline">
          {t('COMMON.LOGIN')}
        </Link>
      </div>
    </AuthLayout>
  );
}
